import { render, staticRenderFns } from "./MultipleItemsInput.vue?vue&type=template&id=08566674&scoped=true"
import script from "./MultipleItemsInput.vue?vue&type=script&lang=ts"
export * from "./MultipleItemsInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08566674",
  null
  
)

export default component.exports